import { Box, useTheme, useMediaQuery } from '@mui/material';
import SidebarMenu from './sidebar-menu/SidebarMenu';

const Sidebar = () => {
  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.up('md'));
  const classes = isLg ? 'large SidebarWrapper ' : 'small SidebarWrapper';
  const wrapperclass =
    theme.palette.mode === 'dark'
      ? 'sidebarwrapperDark'
      : 'sidebarwrapperLight';
  const finalclass = `${classes} ${wrapperclass}`;
  return (
    <Box className={finalclass}>
      <Box className="sidebarScroll">
        <SidebarMenu />
      </Box>
    </Box>
  );
};

export default Sidebar;
